
import { ELECTRICAL_ASPECT_METADATA } from './electrical-aspect.metadata';
import { ElectricalAspect } from './electrical-aspect.model';
import { GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class ElectricalAspectEntityDecoratorBase extends GenericEntityDecorator<ElectricalAspect, number> {
  constructor() {
    super(ELECTRICAL_ASPECT_METADATA, {
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.aspectAssetId == null) {
      return null;
    }
    return parseInt(params.aspectAssetId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: ElectricalAspect): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




